namespace $ {

	$mol_style_define( $shm_projects_goal_chat, {
		flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
		width: '100%',
		height: '100%',
		minHeight: 0,
		Process_view: {
			flex: { direction: 'column', grow: 0, shrink: 0 },
			width: '100%',
			minHeight: 0,
		},
		Process_messages: {
			flex: { direction: 'column' },
			width: '100%',
			gap: $mol_gap.text,
		},
		Chat_page: {
			width: '100%',
			minWidth: 0,
			Body_content: {
				padding: 0,
			},
		},
		Messages_box: {
			width: '100%',
		},
		Message_thinking: {
			minHeight: '2rem',
			margin: { left: $mol_gap.text },
			padding: 0,
			alignItems: 'center',
		},
	} )

}
